import { Route, Routes } from "react-router-dom";
import { AppShell } from "./components/app-shell";
import {
  AccountsPage,
  BillingPage,
  DashboardPage,
  LandingPage,
  LoginPage,
  NotFoundPage,
  PrivacyPage,
  RecentSpamPage,
  SecurityPage,
  TermsPage,
  VerifyPage,
  WorkspacePage,
} from "./pages";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route element={<AppShell />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/accounts" element={<AccountsPage />} />
        <Route path="/workspace" element={<WorkspacePage />} />
        <Route
          path="/workspace/members"
          element={<WorkspacePage showMembers />}
        />
        <Route path="/recent-spam" element={<RecentSpamPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/settings/security" element={<SecurityPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
